import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, UserLoginDto, UserSignUpDto } from '../../models/user.model';
import { TokenStorage } from '../../utils/token-storage';
// Check if user is authenticated on initial load and set it
const { token, user } = TokenStorage.getTokens();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: !!token,
        signUpLoading: false,
        signInLoading: false,
        signInSuccess: false,
        signUpSuccess: false,
        user: user,
    },
    reducers: {
        setTokens: (state, action: PayloadAction<{ token: string; refreshToken: string; user: User }>) => {
            TokenStorage.setTokens(action.payload.token, action.payload.refreshToken, action.payload.user);
            state.isAuthenticated = true;
        },
        clearTokens: (state) => {
            TokenStorage.clearTokens();
            state.isAuthenticated = false;
        },
        signUp: (state, _action: PayloadAction<UserSignUpDto>) => {
            state.signUpLoading = true;
            state.signUpSuccess = false;
        },
        signUpSuccess: (state) => {
            state.signUpLoading = false;
            state.signUpSuccess = true;
        },
        signUpFailed: (state) => {
            state.signUpLoading = false;
            state.signUpSuccess = false;
        },
        signUpReset: (state) => {
            state.signUpLoading = false;
            state.signUpSuccess = false;
        },
        signIn: (state, _action: PayloadAction<UserLoginDto>) => {
            state.isAuthenticated = false;
            state.signInLoading = true;
            state.signInSuccess = false;
        },
        signInSuccess: (state, action) => {
            TokenStorage.setTokens(action.payload.token, action.payload.refreshToken, action.payload.user);
            state.user = action.payload.user;
            state.isAuthenticated = true;
            state.signInLoading = false;
            state.signInSuccess = true;
        },
        signInFailed: (state) => {
            state.signInLoading = false;
            state.signInSuccess = false;
        },
        signInReset: (state) => {
            state.signInSuccess = false;
            state.signInLoading = false;
        },
    },
});

export const {
    setTokens,
    clearTokens,
    signUp,
    signUpSuccess,
    signUpFailed,
    signUpReset,
    signIn,
    signInSuccess,
    signInFailed,
    signInReset,
} = authSlice.actions;
export default authSlice.reducer;
